import React from 'react';

import type { CustomCellRendererProps } from 'ag-grid-react';

import styles from "./WaitlistTab.module.scss";

export const StatusRenderer = (props: CustomCellRendererProps) => {
  const isAwaitingDraw =
    props.value === "waitlist" &&
    props.data?.isLottery &&
    !props.data?.lotteryRanAt;

  const label = isAwaitingDraw ? "Awaiting Draw" : props.value.replace(/_/g, " ");
  const styleKey = isAwaitingDraw ? "awaiting_draw" : props.value;

  return (
    <div className={styles.StatusRenderer}>
      <div className={`${styles.status} ${styles[styleKey]}`}>{label}</div>
    </div>
  );
};